<template>
	<ProductHelpBanner
		v-if="product && loyaltyBanner === 'help'"
		:product="product"
		class="max-md:mx-auto max-xs:-mx-2 mb-8"
	/>
	<ProductMyGlobusBanner
		v-else-if="loyaltyBanner === 'my-globus'"
		class="max-md:mx-auto max-xs:-mx-2 mb-8"
	/>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';
	import {useCustomerProfileStore} from '~/stores/customerProfile';
	import {RIBBON_VHELP_CLUB_ID} from '#shared/constants';

	type Props = {
		product?: ProductDetail;
	};

	const props = defineProps<Props>();

	const customerProfileStore = useCustomerProfileStore();
	const {userIsLogged} = storeToRefs(customerProfileStore);

	const visibleHelpDiscount = computed(() => !!props.product?.productInHouse?.customerClubDiscounts?.find(
		(discount) => discount.customerClub === RIBBON_VHELP_CLUB_ID,
	));

	const loyaltyBanner = computed<'help' | 'my-globus' | null>(() => {
		if (visibleHelpDiscount.value) {
			return 'help';
		}
		if (!userIsLogged.value) {
			return 'my-globus';
		}
		return null;
	});
</script>
